import styles from "./loading.module.css";

function DotLoading() {
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className={styles.loader} />
    </div>
  );
}
export default DotLoading;
